// AWS Amplify Configuration Template - autogenerated at deploy time
/* eslint no-template-curly-in-string: 0*/
const config = {
  s3: {
    REGION: "eu-central-1",
    BUCKET: "app-be-platform-dev-sb-687842713118-uploads",
  },
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://h2dlogd0u9.execute-api.eu-central-1.amazonaws.com/dev/v1",
  },
  cognito: {
    REGION: "eu-central-1",
    USER_POOL_ID: "eu-central-1_QdwV58Y8p",
    APP_CLIENT_ID: "6m62h05uh6rkmuqnev11nvkoai",
    IDENTITY_POOL_ID: "eu-central-1:39230a4a-8d9b-42e8-81af-8f4c696df520",
  },
  locales: {
    URL: "https://locales.platform-dev-sb.dev.beteiligungsboerse.net",
  },
  datastore: {
    URL: "https://datastore.platform-dev-sb.dev.beteiligungsboerse.net",
  },
  registration: {
    URL: "https://registration.platform-dev-sb.dev.beteiligungsboerse.net/v1",
    NEXT_PAGE: "https://app.platform-dev-sb.dev.beteiligungsboerse.net",
    TO_REFERRER: "https://app.platform-dev-sb.dev.beteiligungsboerse.net",
  },
  product: {
    PRODUCT_KEY: "platform",
  },
};

export default config;
